{
  "version": "1.0",
  "chart": "popup",
  "// about": "Self-contained config for the POPUP component — a trigger tile (icon / button / tile) that opens a fully configurable popup dialog (heading / text / key-value / table / buttons / divider content blocks). Static blocks live entirely in the tile's widgetData; table blocks snapshot their rows CLIENT-SIDE from the builder's dataset rows cache at Generate time, so the published view renders with no backend call (the popup is a snapshot-only widget). Deep-merged into the shell via `chartConfigs`.",

  "layoutSteps": {
    "POPUP": {
      "label": "Popup",
      "sections": [
        {
          "id": "config",
          "title": "Popup configuration",
          "hint": "Name the popup and configure how it opens.",
          "fields": [
            { "field": "layoutType", "label": "Layout", "control": "select", "optionsKey": "layoutTypes", "required": true },
            { "field": "title", "label": "Title", "control": "text", "required": true }
          ]
        },
        {
          "id": "popupTrigger",
          "title": "Trigger",
          "hint": "How the popup opens on the dashboard: a compact info icon, a button, or a card-style tile.",
          "fields": [
            { "field": "triggerMode", "label": "Open on", "control": "select", "optionsKey": "popupTriggerModes", "required": true },
            { "field": "triggerIcon", "label": "Icon", "control": "select", "optionsKey": "popupIcons", "hint": "Material icon shown on the trigger." },
            { "field": "triggerLabel", "label": "Trigger label", "control": "text", "hint": "Caption on the button/tile. Defaults to the Title." },
            { "field": "triggerHint", "label": "Hover hint", "control": "text" }
          ]
        },
        {
          "id": "popupBlocks",
          "title": "Popup content",
          "hint": "Build the popup body from blocks: headings, text, key-value audit rows, data tables and action buttons. Blocks render top-to-bottom.",
          "fields": [
            { "field": "blockType", "label": "Block type", "control": "select", "optionsKey": "popupBlockTypes", "repeatable": true, "required": true }
          ]
        },
        {
          "id": "popupBehaviour",
          "title": "Popup behaviour",
          "hint": "Size, position and dismissal of the opened popup.",
          "fields": [
            { "field": "popupSize", "label": "Size", "control": "select", "optionsKey": "popupSizes" },
            { "field": "popupPosition", "label": "Position", "control": "select", "optionsKey": "popupPositions" },
            { "field": "closeLabel", "label": "Close button label", "control": "text", "hint": "Footer close button text. Empty hides the footer button." },
            { "field": "dismissOnBackdrop", "label": "Close on backdrop click", "control": "checkbox" }
          ]
        },
        {
          "id": "popupStyle",
          "title": "Formatting",
          "hint": "Trigger colors plus popup font settings. Leave unset to keep the theme defaults.",
          "fields": [
            { "field": "triggerBg", "label": "Trigger background", "control": "color" },
            { "field": "triggerText", "label": "Trigger text color", "control": "color" },
            { "field": "triggerRadius", "label": "Corner radius (px)", "control": "number" },
            { "field": "cardHeaderBg", "label": "Card header background", "control": "color" },
            { "field": "cardHeaderText", "label": "Card header text color", "control": "color" },
            { "field": "headerBg", "label": "Popup header background", "control": "color" },
            { "field": "headerText", "label": "Popup header text color", "control": "color" },
            { "field": "bodyBg", "label": "Popup background", "control": "color" },
            { "field": "bodyText", "label": "Popup text color", "control": "color" },
            { "field": "buttonBg", "label": "Button color", "control": "color" },
            { "field": "buttonText", "label": "Button text color", "control": "color" },
            { "field": "buttonRadius", "label": "Button corner radius (px)", "control": "number" },
            { "field": "popupRadius", "label": "Popup corner radius (px)", "control": "number" },
            { "field": "fontSize", "label": "Font size (px)", "control": "number" },
            { "field": "fontFamily", "label": "Font family", "control": "select", "optionsKey": "fontFamilies" }
          ]
        }
      ]
    }
  },

  "options": {
    "// popupTriggerModes": "How the POPUP tile renders its trigger on the dashboard. icon = compact round icon button; button = labelled button; tile = card-style tile with icon + label + hint.",
    "popupTriggerModes": [
      { "label": "Icon click", "value": "icon" },
      { "label": "Button click", "value": "button" },
      { "label": "Tile click", "value": "tile" }
    ],
    "// popupIcons": "Material icon choices for the trigger. Values are material icon names.",
    "popupIcons": [
      { "label": "Info", "value": "info" },
      { "label": "Help", "value": "help" },
      { "label": "History / audit", "value": "history" },
      { "label": "Description", "value": "description" },
      { "label": "Table", "value": "table_chart" },
      { "label": "Fact check", "value": "fact_check" },
      { "label": "Warning", "value": "warning" },
      { "label": "Announcement", "value": "campaign" },
      { "label": "Settings", "value": "settings" },
      { "label": "None", "value": "" }
    ],
    "// popupBlockTypes": "The content-block kinds the popup body can hold. Each block row in the builder shows only its own fields (heading text/level, key-value pairs, table dataset+columns, buttons list).",
    "popupBlockTypes": [
      { "label": "Heading", "value": "heading" },
      { "label": "Text", "value": "text" },
      { "label": "Key-value rows", "value": "keyValue" },
      { "label": "Data table", "value": "table" },
      { "label": "API table", "value": "apiTable" },
      { "label": "Buttons", "value": "buttons" },
      { "label": "Divider", "value": "divider" }
    ],
    "// popupApiMethods": "HTTP methods the API-table block can use. The URL is resolved against apiEndpoints.baseUrl when relative; the fetch fires when the popup opens (cached per block unless Refresh-on-open is set).",
    "popupApiMethods": [
      { "label": "GET", "value": "GET" },
      { "label": "POST", "value": "POST" }
    ],
    "// popupValueColors": "Per-column value tint for API-table columns (e.g. Previous Value red, New Value green). Colored columns also appear in the block's legend.",
    "popupValueColors": [
      { "label": "Default", "value": "" },
      { "label": "Red", "value": "red" },
      { "label": "Green", "value": "green" },
      { "label": "Blue", "value": "blue" },
      { "label": "Orange", "value": "orange" }
    ],
    "popupHeadingLevels": [
      { "label": "Large (H1)", "value": "h1" },
      { "label": "Medium (H2)", "value": "h2" },
      { "label": "Small (H3)", "value": "h3" }
    ],
    "// popupButtonActions": "What a button inside a `buttons` block does. close = dismiss; link = open URL in a new tab; navigate = route to another saved/published dashboard.",
    "popupButtonActions": [
      { "label": "Close popup", "value": "close" },
      { "label": "Open link", "value": "link" },
      { "label": "Go to dashboard", "value": "navigate" }
    ],
    "popupButtonStyles": [
      { "label": "Primary", "value": "primary" },
      { "label": "Secondary", "value": "secondary" },
      { "label": "Link", "value": "link" }
    ],
    "popupSizes": [
      { "label": "Small", "value": "small" },
      { "label": "Medium", "value": "medium" },
      { "label": "Large", "value": "large" },
      { "label": "Fullscreen", "value": "fullscreen" }
    ],
    "popupPositions": [
      { "label": "Center", "value": "center" },
      { "label": "Right drawer", "value": "drawer" }
    ],
    "// popupDefaults": "Seed values for a fresh POPUP form.",
    "popupDefaults": {
      "triggerMode": "button",
      "triggerIcon": "info",
      "popupSize": "medium",
      "popupPosition": "center",
      "closeLabel": "Close",
      "tableMaxRows": 50
    },
    "capabilityRegistry": {
      "POPUP": {
        "sections": [
          "Title"
        ]
      }
    },
    "enableFormulaReferences": {
      "POPUP": false
    }
  }
}
